module.exports = __webpack_public_path__ + "static/media/Harry Potter 3.c9a2731d.jpg";